import { Suspense, useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import Spinner from '../ui/Spinner';
import { trackPageView } from '../../services/telemetry';

/** Scroll and focus handoff for client-side navigation. */
function RouteEffects({ mainRef }) {
  const { pathname, hash } = useLocation();
  const previousPath = useRef(pathname);

  useEffect(() => {
    trackPageView(pathname);
    if (!hash) window.scrollTo(0, 0);

    let frame;
    if (!hash && previousPath.current !== pathname) {
      frame = window.requestAnimationFrame(() => {
        mainRef.current?.focus({ preventScroll: true });
      });
    }
    previousPath.current = pathname;
    return () => { if (frame) window.cancelAnimationFrame(frame); };
  }, [pathname, hash, mainRef]);
  return null;
}

export default function Layout() {
  const mainRef = useRef(null);

  return (
    <div className="flex min-h-dvh flex-col">
      <RouteEffects mainRef={mainRef} />
      <a
        href="#main-content"
        className="sr-only z-[70] rounded-full bg-ink px-4 py-2 text-sm font-bold text-white focus:not-sr-only focus:fixed focus:left-4 focus:top-[max(1rem,env(safe-area-inset-top))]">
        Skip to content
      </a>
      <Header />
      <main id="main-content" ref={mainRef} tabIndex={-1} className="flex-1 outline-none">
        <Suspense fallback={<Spinner label="Loading page" />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </div>);

}
